import { selectCurrentRole, useAuthStore } from '@/stores/auth';

interface LimitOverrideCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

/**
 * Caixa "acima do teto" das ações comerciais (C2 da change platform-backoffice-hardening).
 *
 * Só aparece para `Admin`: é o único papel que a API deixa passar do teto, e só com a marca
 * `limitOverride` explícita, auditada como High e avisada aos outros Admins. Para os outros
 * papéis, a marca recebe o mesmo 422, então a tela nem a oferece. Esconder não autoriza nada:
 * a API decide pelo papel do token.
 */
export function LimitOverrideCheckbox({ checked, onChange }: LimitOverrideCheckboxProps) {
  const role = useAuthStore(selectCurrentRole);
  if (role !== 'Admin') return null;

  return (
    <div className="field">
      <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontWeight: 600 }}>
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          style={{ width: 'auto' }}
        />
        Passar acima do teto (exceção de Admin)
      </label>
      <p className="muted" style={{ margin: '4px 0 0', fontSize: 12 }}>
        A ação acima do teto fica na auditoria como sensível e é avisada aos outros Admins.
      </p>
    </div>
  );
}
